module.exports = __webpack_public_path__ + "static/android-f3b9f0b65f8da1490270cad2adcd62e8.png";